<template>
    <!-- <div class="modal-mask">
        <div class="modal-wrapper"> -->
            <div class="h-full ">
                <div class="d-flex h-full flex-column">
                    <TopAppBarDrawer></TopAppBarDrawer>
                    <router-view></router-view>
                    <main class="main-wrapper flex-grow-1">
                        <div class="d-flex align-items-center">
                            <div class="t-headline13 t-color-headlineBlack pda-14 t-center font-m flex-grow-1 fix-header-title">
                                {{$t('460')}}</div>
                        </div>
                        <div class="divider"></div>

                        <!-- subtabs -->

                        <div class="container container--narrow d-flex justify-content-center flex-column">
                            <div class=" t-center">
                                <img src="/images/payment-failed.svg" alt="" class="no-degree-image mgx-auto mgt-100">
                            </div>
                            <div class="mgt-24 t-center t-headline8 font-r t-line-h-28">
                                {{$t('574')}}
                            </div>
                            <div class="mgt-4 t-center t-body1 t-color-bodyGrayA t-line-h-26 font-r">{{$t('575')}}<br>
                                {{$t('576')}}.</div>
                            <div class="mgt-50 t-center">
                                <button @click="moveBack" @keypress="moveBack"
                                    class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8 min-w-100">
                                    <div class="mdc-button__ripple"></div>
                                    <span class="mdc-button__label t-body2 font-r">{{$t('569')}}</span>
                                </button>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        <!-- </div>
    </div> -->
</template>

<script>
    import TopAppBar from '@/components/TopAppBar.vue'
    import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
    import {topAppBarMixin} from '../../mixins/topAppBar.js'
    export default {
	name: '',
	data() {
		return {
            isHomeCategory:false,
		}
	},
	components: {
		TopAppBar, 
		TopAppBarDrawer,
		// 'degree-list': DegreeList
	},

	mixins: [topAppBarMixin],

	mounted() {
        window.onpopstate = function(event) {
     		if(this.fetchType==='LEARN'){
				this.$router.push({
					name:'SalesInformation', 
					params: {goodsid: this.$route.params.goodsid},
					query:  {type: 'ListTotal',fetchType:'LEARN'}
				})
			} else {
				this.$router.push({
					name:'SalesInformation', 
					params: {goodsid: this.$route.params.goodsid},
					query:  {listType: 'total'}
				})
			}
   		};

	},
	methods:{
		moveBack() {
            let id =localStorage.getItem('goodsId')
            let fetchType =localStorage.getItem('fetchType')

            if(fetchType==='LEARN'){
                this.$router.push({
                    name:'SalesCart', 
                    params: {goodsid: id},
                    query:  {type: 'ListTotal',fetchType:'LEARN'}
                })
            } else {
                this.$router.push({
                    name:'SalesCart', 
                    params: {goodsid: id},
                    query:  {listType: 'total'}
                })
            }
        }
	}
}
</script>

<style scoped>
    .payment-failed {
        width: 156px;
        height: 109px;
    }
</style>